module.exports = __webpack_public_path__ + "img/1.575400e2.png";